import { space } from '../spacing.js';
import { sizes } from '../sizing.js';
import { colors } from '../colors.js';
import { radii } from '../radius.js';
import { borderStyles, borderWidths } from '../borders.js';
import { outlines } from '../outlines.js';
import { opacity } from '../opacity.js';
import { iconSizes } from './icons.js';
export const chip = {
    common: {
        borderStyle: borderStyles.solid,
        borderWidth: borderWidths.sm,
        skeletonLoadingColor: 'secondary',
        closeButton: {
            outlineOffset: outlines.item.offset,
        },
    },
    variants: {
        standard: {
            height: sizes.x7,
            minWidth: sizes.x7,
            maxWidth: sizes.x74,
            fontSize: 's',
            lineHeight: 'xs',
            iconSize: iconSizes.standard,
            borderRadius: radii.x3_5,
            padding: space.x2,
            paddingRight: space.x7,
            closeButton: {
                width: sizes.x7,
                height: sizes.x7,
            },
        },
        small: {
            height: sizes.x6,
            minWidth: sizes.x6,
            maxWidth: sizes.x56,
            fontSize: 'xs',
            lineHeight: 'xs',
            iconSize: iconSizes.small,
            borderRadius: radii.x3,
            padding: space.x2,
            paddingRight: space.x6,
            closeButton: {
                width: sizes.x6,
                height: sizes.x6,
            },
        },
    },
    states: {
        default: {
            backgroundColor: colors.backgrounds.onGray,
            borderColor: colors.borders.default,
            color: colors.text.default,
        },
        hover: {
            backgroundColor: colors.controls.secondaryHover,
            borderColor: colors.controls.secondaryHover,
            color: colors.text.default,
        },
        active: {
            backgroundColor: colors.controls.secondaryActive,
            borderColor: colors.controls.secondaryActive,
            color: colors.text.default,
        },
        pressed: {
            backgroundColor: colors.backgrounds.accent,
            borderColor: colors.borders.primary,
            color: colors.text.primary,
        },
        disabled: {
            opacity: opacity.faded,
        },
        focus: {
            outline: outlines.control,
            outlineNone: outlines.none,
        },
    },
};
//# sourceMappingURL=chip.js.map